<template>
  <div
    :style="getModulePreviewStyle()"
    class="module-preview">
    <div
      :style="getModuleIconStyle()"
      class="module-icon"/>
    <div
      :style="getModuleTextStyle()"
      class="module-text"> {{ module.tmo_data && !module.modu_act_id ? module.tmo_data.name : module.modu_name }}</div>
  </div>
</template>

<script>

export default {
  name: 'ModulePreview',
  props: {
    module: {
      type: Object,
      default: null,
    },
    theme: {
      type: Object,
      default: null,
    },
    order: {
      type: Number,
      default: 1,
    },
    length: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      title: 'Module Preview',
      iconBase64: null,
      computedOrder: 0,
    };
  },
  computed: {

  },
  mounted() {
    if (this.module.tma_ass_id) {
      this.$store.dispatch('establishments/getBase64Icon', this.module.tma_ass_id)
        .then((response) => { this.iconBase64 = response.data; });
    }
    this.computedOrder = this.order + 1;
    if (this.length > 9 && this.computedOrder > 8) {
      this.computedOrder = this.computedOrder - (8 * Math.floor(this.computedOrder / 8));
    } else if (this.length > 16 && this.computedOrder > 15) {
      this.computedOrder = this.computedOrder - (15 * Math.floor(this.computedOrder / 15));
    }
  },
  methods: {
    getModulePreviewStyle() {
      return {
        background: this.getColorFromTheme('background'),
        border: `1px solid ${this.getColorFromTheme('border')}`,
      };
    },
    getModuleIconStyle() {
      return {
        'background-image': `url('data:image/png;base64,${this.iconBase64}'`,
        height: this.getImageSize(),
      };
    },
    getModuleTextStyle() {
      return {
        background: this.getColorFromTheme('text_background'),
        'text-transform': this.getColorFromTheme('text_all_caps'),
        color: this.getColorFromTheme('text'),
        display: this.getTextDisplay(),
      };
    },
    getColorFromTheme(source) {
      if (this.module.modu_act_id) {
        switch (source) {
          case 'text':
            return '#FFFFFF';
          case 'text_background':
            return this.module.dom_color;
          case 'text_all_caps':
            return 'none';
          case 'background':
            return this.module.dom_color;
          case 'border':
            return this.module.dom_color;
          default:
            return '#FFFFFF';
        }
      } else if (this.theme && this.theme.tile_theme && this.theme.tile_theme[`tile_${this.computedOrder}`]) {
        const defaultBackground = this.theme.tile_theme[`tile_${this.computedOrder}`].background
          ? this.theme.tile_theme[`tile_${this.computedOrder}`].background
          : this.theme.tile_theme[`tile_${this.computedOrder}`];
        switch (source) {
          case 'text':
            return this.theme.tile_theme[`tile_${this.computedOrder}`].text
              ? this.theme.tile_theme[`tile_${this.computedOrder}`].text
              : '#FFFFFF';
          case 'text_background':
            return this.theme.tile_theme[`tile_${this.computedOrder}`].text_background
              ? this.theme.tile_theme[`tile_${this.computedOrder}`].text_background
              : defaultBackground;
          case 'text_all_caps':
            return this.theme.tile_theme[`tile_${this.computedOrder}`].text_caps
              ? 'uppercase'
              : 'none';
          case 'background':
            return defaultBackground;
          case 'border':
            return this.theme.tile_theme[`tile_${this.computedOrder}`].border
              ? this.theme.tile_theme[`tile_${this.computedOrder}`].border
              : defaultBackground;
          default:
            return '#FFFFFF';
        }
      }
      return 'inherit';
    },
    getImageSize() {
      if (this.module.modu_act_id) {
        return '80px';
      }
      return this.module.tmo_data && this.module.tmo_data.name && this.module.tmo_data.name.length > 0 ? '80px' : '120px';
    },
    getTextDisplay() {
      if (this.module.modu_act_id) {
        return 'block';
      }
      return this.module.tmo_data && this.module.tmo_data.name && this.module.tmo_data.name.length > 0 ? 'block' : 'none';
    },
  },
};
</script>
<style>
  .module-preview {
    width: 120px;
    height: 120px;
    text-align: center;
    border: 1px solid #83cee6;
    margin: auto;
    border-radius: 5px;
  }
  .module-icon {
    height: 80px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-origin: content-box;
    margin: auto;
    border-radius: 5px 5px 0 0;
    padding: 5px;
  }
  .module-text {
    width: 118px;
    height: 38px;
    background: gold; /* TODO : Paramétrer selon le thème */
    color: white; /* TODO : Paramétrer selon le thème */
    font-size: .8em;
    font-weight: bold;
    padding-top: .8em;
    margin: auto;
    border-radius: 0 0 5px 5px;
  }
</style>
